import { useState } from 'react';

// Whether the teacher wants the French subtitle field. Some videos already
// have French captions on YouTube, so the teacher adds only English.
// Remembered per browser; shared by the add and edit subtitle forms.
const FRENCH_FIELD_KEY = 'hoja_subtitle_french_field';

function load() {
  try { return localStorage.getItem(FRENCH_FIELD_KEY) !== 'hidden'; } catch (e) { return true; }
}

export default function useFrenchField() {
  const [showFrench, setState] = useState(load);
  const setShowFrench = (show) => {
    setState(show);
    try { localStorage.setItem(FRENCH_FIELD_KEY, show ? 'shown' : 'hidden'); } catch (e) { /* ignore */ }
  };
  return [showFrench, setShowFrench];
}
